import { render, staticRenderFns } from "./ConversationItem.vue?vue&type=template&id=7e6f95c3&scoped=true"
import script from "./ConversationItem.vue?vue&type=script&lang=js"
export * from "./ConversationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6f95c3",
  null
  
)

export default component.exports